import { useEffect } from 'react';
import { getSessionToken } from './safeStorage';

// The heartbeat behind login times and session durations (admin dashboard). While a signed-in student is actually using the site (page visible AND a mouse
// move, key press, scroll or touch in the last 3 minutes), one small request a minute says "still here". Nothing is sent for a tab left open and idle, or for
// someone who is not signed in. If the server says tracking is not switched on (SQL 427 not run) it stops for the rest of the visit.
export const PING_EVERY_MS = 60 * 1000;
export const IDLE_AFTER_MS = 3 * 60 * 1000;

export function newVisitId() {
  try { if (window.crypto && window.crypto.randomUUID) return window.crypto.randomUUID().replace(/-/g, ''); } catch { /* fall through */ }
  return `v${Date.now().toString(36)}${Math.random().toString(36).slice(2, 10)}`;
}

// `active` is true only on the SAT pages (the same student login is used elsewhere on the site, and that is never tracked here).
export default function useActivityPing(active = true) {
  useEffect(() => {
    if (!active) return undefined;
    let visitId = null;
    try { visitId = sessionStorage.getItem('preppeak-visit'); } catch { /* a new id per page load is fine */ }
    if (!visitId) { visitId = newVisitId(); try { sessionStorage.setItem('preppeak-visit', visitId); } catch { /* ignore */ } }
    let lastInput = Date.now();
    let stopped = false;
    const mark = () => { lastInput = Date.now(); };
    const events = ['mousemove', 'keydown', 'scroll', 'touchstart', 'click'];
    events.forEach((e) => window.addEventListener(e, mark, { passive: true }));
    const send = () => {
      const token = getSessionToken();
      if (stopped || !token || document.visibilityState === 'hidden' || Date.now() - lastInput > IDLE_AFTER_MS) return;
      fetch('/api/sat?action=activity-ping', { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify({ visitId }) })
        .then((r) => (r && r.ok ? r.json() : null))
        .then((d) => { if (d && d.enabled === false) stopped = true; })
        .catch(() => {});
    };
    send();
    const timer = setInterval(send, PING_EVERY_MS);
    return () => { clearInterval(timer); events.forEach((e) => window.removeEventListener(e, mark)); };
  }, [active]);
}
